import { ValidatingInput, InputComponentProps } from '~/components/validating-input';
import { CustomerAccountType } from '~/typings/graphql';

export const AccountEntityName = ({
  customerType,
  ...props
}: InputComponentProps & {
  customerType?: CustomerAccountType;
}) => {
  const validate = ({ value }) => {
    const regex = /^[a-zA-ZÀ-ÖØ-öø-ÿ' -]+$/;
    if (value.trim().length < 1) {
      return customerType === CustomerAccountType.Business
        ? 'Please enter the business name'
        : "Please enter the utility account holder's name";
    }
    if (!regex.test(value.trim())) return 'Please enter a valid name';

    return true;
  };

  return (
    <ValidatingInput
      autoComplete="given-name"
      label={
        customerType === CustomerAccountType.Business ? 'Business name' : "Account holder's name"
      }
      name="accountHolderName"
      placeholder={
        customerType === CustomerAccountType.Business ? 'Business name' : "Account holder's name"
      }
      maxLength={128}
      validate={validate}
      {...props}
    />
  );
};
